// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main--default{padding-top:78px}@media (max-width:1440px){.main--default{padding-top:79px}}@media (max-width:991px){.main--default{padding-top:48px}}", ""]);
// Exports
module.exports = exports;
